// [목적] 강원캔버스 spacing 토큰 (design_structure §3-3) — 4 단위 기반
// [이유] CLAUDE.md §6-3 — px 직접 입력 금지, 본 토큰만 사용
// [사이드 이팩트] MUI 테마 spacing 함수 파생 / 모든 padding/margin/gap 값
// [수정 시 고려사항] 4의 배수 체계는 design_structure §3-3 결정. 변경 시 모든 컴포넌트 시각 검증 필요

export const spacing = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
  16: 64,
} as const;

export type SpacingTokens = typeof spacing;
export type SpacingKey = keyof typeof spacing;
